import { styled } from '@mui/material';

export const StyledLogoContainer = styled('a')(({ theme }) => ({
  padding: theme.spacing(0, 2, 0, 0),
  cursor: 'pointer'
}));
